<template>
  <info-section
    class="mb-4"
    :total="allUserSocials.length"
    :pending="socials.pending"
    icon="mdi-account-box"
    title="Социальные аккаунты"
    :pages="socialPageCount"
    :current-page="socials.page"
    @setPage="setPage"
  >
    <social-card
      v-for="social in displayedUserSocials"
      :key="social.id"
      :social="social"
      :last-modify="lastModifies[social.id]"
      class="contact-item"
    />

    <div v-if="!allUserSocials.length && !socials.pending">
      Нет связанных социальных аккаунтов
    </div>
  </info-section>
</template>

<script>
import InfoSection from "@/components/InfoSection.vue";
import SocialCard from "@/components/contact/SocialCard.vue";
import { PROVIDERS_FOR_SYNC } from "@/constants";

export default {
  name: "SocialAccounts",
  components: { SocialCard, InfoSection },
  props: {
    socials: {
      type: Object,
      required: true,
    },
    allUserSocials: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    displayedUserSocials() {
      const start = (this.socials.page - 1) * this.socials.limit;
      const end = start + this.socials.limit;
      return this.allUserSocials.slice(start, end);
    },
    socialPageCount() {
      return Math.ceil(this.allUserSocials.length / this.socials.limit);
    },
    lastModifies() {
      if (!this.allUserSocials.length) {
        return {};
      }
      return this.allUserSocials.reduce((acc, item) => {
        if (PROVIDERS_FOR_SYNC[item.provider]) {
          acc[item.id] = item.modified;
        }
        return acc;
      }, {});
    },
  },
  methods: {
    setPage(page) {
      this.$emit("setPage", page);
    },
  },
};
</script>
